import React from 'react';
import { motion } from 'framer-motion';

const AboutPage = () => {
    return (
        <motion.div
            key="about"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="max-w-4xl mx-auto p-4 md:p-8"
        >
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
                    About VolunGo
                </h1>
                <p className="text-lg text-gray-600">
                    Because every hand can help.
                </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Our Mission</h2>
                    <p className="text-gray-600 leading-relaxed">
                        To seamlessly connect volunteers with NGOs, fostering meaningful impact in communities worldwide. We believe in the power of collective action to solve social challenges efficiently and effectively.
                    </p>
                </div>
                <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Our Vision</h2>
                    <p className="text-gray-600 leading-relaxed">
                        To build a global, technology-driven network where anyone can easily find and engage in volunteer opportunities, and organizations can effortlessly manage their volunteer needs.
                    </p>
                </div>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-12">
                <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Our Founder</h2>
                <div className="flex flex-col md:flex-row justify-center items-center gap-10">
                    <div className="text-center">
                        {}
                        <img 
                            src="/WhatsApp Image 2025-07-26 at 19.28.46_422a1adf.jpg" 
                            alt="Founder"
                            className="w-24 h-24 rounded-full mx-auto mb-4 border-2 border-gray-300"
                        />
                        <h4 className="font-bold text-lg text-gray-900">Nasrullah Babar Mufti</h4>
                        <p className="text-gray-500">Founder & CEO</p>
                    </div>
                </div>
            </div>

            <div className="text-center text-gray-500 text-sm">
                <p>Have questions? Reach out to us at <a href="mailto:contact@volungo.org" className="text-gray-800 hover:underline">contact@volungo.org</a></p>
                <p>&copy; {new Date().getFullYear()} VolunGo. All Rights Reserved.</p>
            </div>
        </motion.div>
    );
};

export default AboutPage;
